export default {
  state: {
    user: null,
    showSiteLoader: true,
    sendAuthzHeader: true
  },

  getters: {
    currentUser(state) {
      return state.user;
    },

    isAuthorized(state) {
      return !!state.user;
    },

    showSiteLoader(state) {
      return state.showSiteLoader;
    },

    sendAuthzHeader(state) {
      return state.sendAuthzHeader;
    }
  },

  mutations: {
    setUser(state, user) {
      state.user = user || null;
      state.showSiteLoader = false;
    },

    setSendAuthzHeader(state, send) {
      state.sendAuthzHeader = send;
    }
  }
};
